<template>
  <co-dialog
    v-model="isShow"
    :title="$t('审批申请')"
  >
    <section class="link-approval-content">
      <span class="link-approval-title">{{ $t('该内容的操作需经过审批后才可生效，是否提交审批？') }}</span>
      <div class="link-approval-body">
        <span
          v-show="!isThirdParty"
          class="link-approval-name"
        >{{ $t('审批者：') }}</span>
        <div
          v-show="!isThirdParty"
          class="link-approval-main"
        >
          <div
            v-for="(approver, index) in approvers"
            :key="index"
            class="link-approval-personnel"
          >
            <span
              class="profile"
              :style="{ background : approver['color'] }"
            >{{ approver['user_name'].substring(0,1) }}</span>
            <span class="name">{{ approver['user_name'] }}</span>
            <span class="email">{{ approver['email'] }}</span>
          </div>
        </div>
        <div class="link-approval-explain">
          <textarea
            v-model="explaination"
            v-ie-placeholder
            maxlength="100"
            cols="30"
            rows="10"
            class="explaination"
            :class="[(isThirdParty? 'approve_true': '')]"
            :placeholder="this.$t('可添加审批申请说明')"
          />
          <span
            :class="['fr',explaination.length === 100 ? 'text-invalidate' : '']"
          >
            {{ explaination.length }}/100
          </span>
        </div>
      </div>
    </section>
    <template slot="button">
      <div class="link-approval-btn clearfix">
        <div
          class="lv-bn lv-80 c-btn"
          @click="clickCancle"
        >
          {{ $t('取消') }}
        </div>
        <div
          class="lv-bn lv-80 s-btn cp"
          @click="submit"
        >
          {{ confirmBtn }}
        </div>
      </div>
    </template>
  </co-dialog>
</template>
<script>
import coDialog from 'components/common/dialog/index.vue'
import { isExistPolicy, getPolicyApprover } from 'js/api/privateApi/private-apis'

import _$ from 'js/api/getdata'

export default {
  name: 'RequestApproval',
  components: {
    coDialog,
  },
  props: {
    otherData: { // 创建新链接所需的数据
      type: Object,
      default: () => {},
    },
    isThirdParty: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      param: {}, // 请求参数
      explaination: '', // 审批说明
      approvers: [], // 审批者列表
      isAsync: false,
      isShow: false,
    }
  },
  computed: {
    pathType() {
      const { $route } = this
      return $route.meta.path_type || $route.name
    },
    confirmBtn() {
      return this.isAsync ? this.$t('正在提交') : this.$t('确定')
    },
    curFileInfo() {
      return this.$store.state.curFileInfo
    },
  },
  methods: {
    init() {
      this.explaination = '' // 审批说明设为空
      this.approvers = this.otherData.approvers
    },
    linkRefresh() { // 外链创建后局部刷新
      this.$emit('getData', { refresh: true, neid: this.$route.params.id })
    },
    // 获取提交地址
    getUrl(type) {
      const urls = {
        download: 'apprDownload',
      }
      return urls[type]
    },
    // 获取提交参数
    getParams(type) {
      const url = this.getUrl(type)
      const neids = Array.isArray(this.otherData.neids) ? this.otherData.neids.join(',') : this.otherData.neids
      const { revision, nsid } = this.otherData
      if (type === 'remove' || type === 'download') {
        return {
          url,
          params: {
            nsid,
            neids,
            revision,
            apply_desc: this.explaination,
          },
        }
      }
      if (type === 'upload') {
        return {
          url,
          params: {
            nsid: this.otherData.nsid,
            neid: this.otherData.neid,
            task_id: this.otherData.taskId,
            apply_desc: this.explaination,
          },
        }
      }
      return false
    },
    approvalCallback(tips) {
      window.$toast.simpleShow(tips, 'warn')
      this.isAsync = false
      this.isShow = false
    },
    deliveryApproval(params, url) {
      _$.postData('deliveryCreate', params, { url }).then(() => {
        const tips = this.$t('审批已提交，请等待审批结果，通过后，链接立即生效')
        this.approvalCallback(tips)
      }).catch((err) => {
        this.approvalCallback((err.response
          && err.response.data
          && err.response.data.message
        )
          || err.message)
      })
    },
    downloadApproval() {
      const { url, params } = this.getParams('download')
      _$.postData(url, params).then(() => {
        const tips = this.$t('审批已提交，请等待审批结果')
        this.approvalCallback(tips)
      }).catch((err) => {
        this.approvalCallback((err.response
            && err.response.data
            && err.response.data.message
        )
          || err.message)
      })
    },
    // 提交方法
    submit() {
      const { linkshareparams, approvalType } = this.otherData
      if (approvalType === 'delivery') {
        const params = {
          path: linkshareparams.path,
          path_type: linkshareparams.path_type,
          ...linkshareparams.linkShareSubmitFormDataParams,
        }
        const url = params.path
        params.approve_desc = this.explaination
        delete params.path
        this.isAsync = true
        this.deliveryApproval(params, url)
      }
      if (approvalType === 'download') {
        this.downloadApproval()
      }
    },
    clickSure() {
      this.createLink(this.linkRefresh)
    },
    clickCancle() {
      this.isShow = false
    },
    show() {
      this.init()
      this.isShow = true
    },
  },
}
</script>
<style lang="less">
.link-approval-content {
  .el-input {
    .el-input__inner {
      height: 32px;
      border-color: #c1cdc7;
    }
  }
  textarea {
    resize: none;
    overflow: auto;
  }
   .explaination {
    background-color: #fff;
    background-image: none;
    border-radius: 2px;
    border: 1px solid #c1c7cd;
    box-sizing: border-box;
    color: #1b2733;
    display: inline-block;
    font-size: inherit;
    height: 32px;
    line-height: 32px;
    padding: 0 15px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
    :-ms-input-placeholder{
      color:#929ca9;
    }
    &::placeholder{
      color: #929ca9;
    }
    &:focus {
      border-color: #409eff;
      outline: 0
    }
  }
    .approve_true {
        height: 90px;
    }

}
</style>
<style lang="less" scoped>
@import '~less/button.less';
.fr{
  float:right
}
.text-invalidate{
  color: #FF1B43;
}
.link-approval-content {
  width: 520px;
  padding: 0 24px 24px 24px;
  box-sizing: border-box;
  & .link-approval-title {
    display: inline-block;
    margin-bottom: 20px;
    color: #1B2733;
  }
  & .link-approval-body {
    & .link-approval-name {
      float: left;
      height: 24px;
      line-height: 24px;
      color: #637282
    }
    & .link-approval-main {
      display: inline-block;
      width: 350px;
      height: 209px;
      margin-left: 24px;
      box-sizing: border-box;
      & .link-approval-personnel {
        margin-bottom: 20px;
        .profile {
          display: inline-block;
          width: 24px;
          height: 24px;
          line-height: 24px;
          border-radius: 50%;
          background-color: #666;
          color: #FFF;
          text-align: center;
          margin-right: 12px;
          float: left;
        }
        .name {
          display: inline-block;
          width: 23%;
          height: 24px;
          line-height: 24px;
          color: #1b2733;
          font-size: 14px;
          vertical-align: middle;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          float: left;
        }
        .email{
          width: 60%;
          height: 24px;
          line-height: 24px;
          font-size: 14px;
          color: #637282;
          float: left;
        }
      }
    }
    & .link-approval-explain {
      margin-top: 10px;
    }
  }
}
.link-approval-btn {
  width: 100%;
  text-align: right;
  box-sizing: border-box;
  padding:0 24px 24px 24px;
  font-size: 0;
  .lv-bn{
    margin-left: 12px;
  }
  .button {
    display: inline-block;
    width: 110px;
    height: 38px;
    font-size: 15px;
    line-height: 38px;
    text-align: center;
    vertical-align: middle;
    border-radius: 2px;
    cursor: pointer;
  }
  .sure {
    width: 80px;
    height: 32px;
    line-height: 32px;
    color: #fff;
    border: 1px solid #2c7df1;
    background: #2c7df1;
    float: right;
    margin-left: 12px;
  }
  .disable-btn{
    background:rgb(132, 177, 252);
    color:rgb(173,194,227);
    pointer-events:none;
  }
  .cancle {
    width: 80px;
    height: 32px;
    line-height: 32px;
    margin-left: 20px;
    margin-right: 12px;
    color: #1b2733;
    border: 1px solid #c1c7cd;
    float: right;
  }
}
</style>
